import $ from 'jquery';

$(function(){
  $(".accordion_search_area span.span_txt").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });
});
